module.exports = require('./helpers/bundle-url').getBundleURL('gA8FI') + "luca-company.ebbca258.webp";